import api from './api';

export interface WsfeConfigItem {
    idwsfe: string;
    descripcion: string;
}

const wsfeConfigService = {
    getWsfeConfigs: async (): Promise<WsfeConfigItem[]> => {
        const response = await api.get<WsfeConfigItem[]>('/api/WsfeConfig');
        return response.data || [];
    }
};

export default wsfeConfigService;
